import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { LaboratoryInfoQuery, LaboratoryInfoQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(LaboratoryInfoQuery)
@Wrapper(LaboratoryInfoQueryHandlerBase)
export class LaboratoryInfoQueryHandler {
    public constructor(
        http: Http
    ) { }
}
